import { defineHierarchyChart } from '@rdrive/helper-chart-config';

// Issue breakdown by drawing set -> drawing -> location -> single location, for
// @rdrive/plugin-chart-stacked-bar's StackedHorizontalBarChart (IA_ABSORPTION_PLAN Phase 4 step
// 12a; was components/charts/DrawingDrawingCategoryStackedBarChart.vue). Since Phase 5 step 5.1 a
// level table on `defineHierarchyChart` (@rdrive/helper-chart-config) — the generated queries
// equal the old hand-written ones (tooling/parity/hierarchy-chart/), and every filter value goes
// through escapeSql (rule 6). Rendered on the Drawings page.
//
// The providers honour the base's `filtered` flag (`issues` for its breadcrumb lookup). A
// drawing-set bar's id is the set's TITLE; its filter reads the set id the row carries as parentId.

const LOCATIONS = 'JOIN locations l ON i.issueLocationId = l.id';
const DRAWINGS = 'JOIN drawings d ON l.drawingId = d.id';

const LOCATION_LEVEL = {
  level: 'locations', titleKey: 'locations',
  id: 'l.id', title: 'l.title', joins: [LOCATIONS],
  filter: { where: [['i.issueLocationId', 'id']] },
};

export function useDrawingCategoryChart({ chartName, filterContext, conn }) {
  return defineHierarchyChart({
    chartName,
    filterContext,
    conn,
    source: { table: (filtered) => (filtered ? 'filteredIssues' : 'issues'), alias: 'i' },
    status: { join: 'JOIN status_templates s ON i.issueStatusId = s.id' },
    filter: { table: 'issues', keys: 'i.id' },
    levels: [
      {
        level: 'drawingsets', titleKey: 'drawingSets',
        id: 'd.drawingSetTitle', parentId: 'd.drawingSetId', title: 'd.drawingSetTitle', joins: [LOCATIONS, DRAWINGS],
        filter: { joins: [LOCATIONS, DRAWINGS], where: [['d.drawingSetId', 'parentId']] },
      },
      {
        level: 'drawings', titleKey: 'drawings',
        id: 'l.drawingId', title: 'l.drawingTitle', joins: [LOCATIONS],
        filter: { joins: [LOCATIONS], where: [['l.drawingId', 'id']] },
      },
      LOCATION_LEVEL,
      // The terminal level repeats the locations; it has no filter, so a click there stays inert
      { ...LOCATION_LEVEL, level: 'singleLocation', filter: null },
    ],
  });
}
